import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs, useMediaQuery, useTheme } from "@mui/material";
import { useRouteMatch } from "../../hooks/useRouteMatch";
import { BreadCrumbItem } from "./BreadCrumbItem";
import { tokenReplace } from "../../utils/tokenReplacement";
import { useCompanyConfigQuery } from "../../../SWR/Company/useCompanyConfigQuery";
function handleClick(event) {
    event.preventDefault();
    //TODO: Maybe Add Click Actions?
}
export default function IconBreadcrumbs() {
    const theme = useTheme();
    const { tokenMap } = useCompanyConfigQuery();
    const { isOrderFlowPage, isLocationPage, isGiftCardFlow, isCheckOutOrThankYouPage } = useRouteMatch();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    return (_jsxs(Breadcrumbs, Object.assign({ separator: " ", "aria-label": "breadcrumb", sx: {
            marginBottom: isDesktop ? "initial" : theme.spacing(1),
            "& ol": {
                justifyContent: isDesktop ? "flex-end" : "space-evenly",
            },
        } }, { children: [_jsx(BreadCrumbItem, { crumbNumber: 1, isActive: !!isLocationPage, label: "Welcome", handleClick: handleClick }), !isGiftCardFlow && (_jsx(BreadCrumbItem, { crumbNumber: 2, isActive: !!isOrderFlowPage, label: tokenReplace("Choose Your {meal_entity_name_plural}", true, tokenMap), handleClick: handleClick })), _jsx(BreadCrumbItem, { crumbNumber: isGiftCardFlow ? 2 : 3, isActive: !!isCheckOutOrThankYouPage, label: "Checkout", handleClick: handleClick })] })));
}
